import { Alert, Typography } from "@mui/material"

import {
	horariosLinhasParticipacao,
	ordenarLinhasParticipacao,
	resolverStatusParticipacaoDia,
	resumoParticipacaoVaga,
} from "./gestaoVagaParticipacaoUtil.js"

/**
 * Grade de dias (semana + datas) e situação do profissional na vaga — detalhes da fila.
 */
export default function GestaoVagaFilaDetalheParticipacao({ vaga }) {
	const msg = vaga?.mensagem ?? {}
	const linhas = ordenarLinhasParticipacao(horariosLinhasParticipacao(vaga))
	const resumo = resumoParticipacaoVaga(vaga)

	if (!vaga) return null

	if (linhas.length === 0) {
		return (
			<Alert severity="info" className="gv-alert-linha-toda">
				Nenhum dia com horário configurado para esta vaga.
			</Alert>
		)
	}

	return (
		<div className="gv-fila-participacao">
			{msg.descricao ? (
				<Typography variant="body2" className="gv-fila-participacao__descricao whitespace-pre-wrap m-0 mb-3">
					{msg.descricao}
				</Typography>
			) : null}

			<div className="gv-fila-participacao__resumo">
				{resumo.titular > 0 ? (
					<span className="gv-chip gv-chip--ok gv-chip--sm">
						{resumo.titular === 1
							? "1 dia como titular"
							: `${resumo.titular} dias como titular`}
					</span>
				) : null}
				{resumo.podeIngressar > 0 ? (
					<span className="gv-chip gv-chip--brand gv-chip--sm">
						{resumo.podeIngressar === 1
							? "1 dia pode ingressar"
							: `${resumo.podeIngressar} dias pode ingressar`}
					</span>
				) : null}
				{resumo.aguardando > 0 ? (
					<span className="gv-chip gv-chip--warn gv-chip--sm">
						{resumo.aguardando === 1
							? "1 dia aguardando"
							: `${resumo.aguardando} dias aguardando`}
					</span>
				) : null}
			</div>

			<p className="gv-fila-participacao__legenda m-0">
				Dias da semana com a próxima data na janela. <strong>Titular</strong> = você já
				ingressou; <strong>Pode ingressar</strong> = ainda há vaga para se candidatar.
			</p>

			<ul className="gv-fila-participacao__lista">
				{linhas.map((linha) => {
					const slot = linha.slot
					const status = resolverStatusParticipacaoDia(slot)
					const dataLabel =
						slot?.dataFormatada ||
						(slot?.data ? String(slot.data) : "") ||
						"—"
					const diaLabel = linha.diaNome || linha.diaAbrev || "Dia"

					return (
						<li
							key={`${linha.diaSemana}-${linha.diaId}-${linha.texto}`}
							className={`gv-fila-participacao__item gv-fila-participacao__item--${status.grupo}`}
						>
							<div className="gv-fila-participacao__item-head">
								<div className="gv-fila-participacao__item-titulos">
									<span className="gv-fila-participacao__dia">{diaLabel}</span>
									<span className="gv-fila-participacao__data">{dataLabel}</span>
								</div>
								<span className={`gv-chip gv-chip--${status.variant} gv-chip--sm`}>
									{status.label}
								</span>
							</div>
							<p className="gv-fila-participacao__horario m-0">{linha.texto}</p>
							{status.detalhe ? (
								<p className="gv-fila-participacao__detalhe m-0">{status.detalhe}</p>
							) : null}
						</li>
					)
				})}
			</ul>
		</div>
	)
}
